import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import './About.scss';

const About = () => {
	const history = useHistory();

	useEffect(() => window.scrollTo(0, 0), []);
	
	if (window.localStorage.getItem('account') === 'true') {
		history.push("/panel-control");
	}
	return (
		<section className="about">
			<p>
				Celular Fire es una empresa que se fundó en 2010. Nos dedicamos a
				distribuir refacciones para dispositivos móviles ofreciendo a nuestros
				clientes un producto con la mejor relación calidad precio en displays,
				baterías, flexores, tapas traseras y más, garantizando el mejor trato de
				nuestros colaboradores y el excelente funcionamiento de su equipo
				gastando menos. Sobresalimos por ser honestos y dedicados, teniendo 10
				años de experiencia en el mercado.
			</p>
			<h5>Misión</h5>
			<p>
				Resolver las necesidades de nuestros clientes con una excelente atención
				y la más alta disponibilidad de refacciones de la mejor calidad para
				cualquier marca reconocida en México.
			</p>
			<h5>Visión</h5>
			<p>
				Destacar de entre las mejores empresas de distribución de refacciones
				para dispositivos móviles y mantener una metodología de trabajo
				sustentable.
			</p>
			<h5>Valores</h5>
			<p>
				Respeto, Confianza, Cordialidad, Actitud de servicio, Honradez,
				Profesionalismo, Cooperación, Transparencia, Excelencia
			</p>
		</section>
	);
};

export default About;
